import { createSlice } from "@reduxjs/toolkit";
import { assignFormToProfile } from "./actions/assignFormToProfile";

import { findFormList } from "./actions/findFormList";
import { findFormListByProfile } from "./actions/findFormListByProfile";

interface ProfileFormAssignedState {
    findFormListStatus: "idle" | "pending" | "succeeded" | "failed";
    findFormListByProfileStatus: "idle" | "pending" | "succeeded" | "failed";
    assignFormToProfileStatus: "idle" | "pending" | "succeeded" | "failed";
    formList: { id: string, name: string }[];
    searchText: string;
    preselectedForms: { id: string, name: string }[];
    assignedForms: { pfId: string, id: string, name: string}[];
}

const initialState = {
    findFormListStatus: "idle",
    findFormListByProfileStatus: "idle",
    assignFormToProfileStatus: "idle",
    formList: [],
    searchText: "",
    preselectedForms: [],
    assignedForms: [],
} as ProfileFormAssignedState;

const profileFormAssignedSlice = createSlice({
    name: "profileForm",
    initialState,
    reducers: {
        setSearchText(state, { payload }) {
            state.searchText = payload;
        },
        setPreselectedForm(state, { payload }) {
            state.preselectedForms = [...state.preselectedForms, payload];
        },
        setPreselectedAll(state, { payload }) {
            state.preselectedForms = [...state.preselectedForms, ...payload];
        },
        setDeselectForm(state, { payload }) {
            state.preselectedForms = state.preselectedForms.filter(({ id }) => id !== payload);
        },
        setDeselectAll(state) {
            state.preselectedForms = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(findFormList.pending, (state) => {
                state.findFormListStatus = "pending";
                state.formList = [];
            })
            .addCase(findFormList.fulfilled, (state, { payload }) => {
                state.findFormListStatus = "succeeded";
                state.formList = [...payload];
            })
            .addCase(findFormList.rejected, (state) => {
                state.findFormListStatus = "failed";
                state.formList = [];
            })
            .addCase(findFormListByProfile.pending, (state) => {
                state.findFormListByProfileStatus = "pending";
                state.preselectedForms = [];
                state.assignedForms = [];
            })
            .addCase(findFormListByProfile.fulfilled, (state, { payload }) => {
                state.findFormListByProfileStatus = "succeeded";
                state.preselectedForms = payload.map((item: { pfid: number, id: number, name: string }) => {
                    return { id: item.id, name: item.name }
                })
                state.assignedForms = [...payload]
            })
            .addCase(findFormListByProfile.rejected, (state) => {
                state.findFormListByProfileStatus = "failed";
                state.preselectedForms = [];
                state.assignedForms = [];
            })
            .addCase(assignFormToProfile.pending, (state) => {
                state.assignFormToProfileStatus = "pending";
            })
            .addCase(assignFormToProfile.fulfilled, (state) => {
                state.assignFormToProfileStatus = "succeeded";
            })
            .addCase(assignFormToProfile.rejected, (state) => {
                state.assignFormToProfileStatus = "failed";
            });
    },
});

export const {
    setSearchText,
    setPreselectedForm,
    setPreselectedAll,
    setDeselectForm,
    setDeselectAll,
} = profileFormAssignedSlice.actions;

export default profileFormAssignedSlice.reducer;